import * as moment from 'moment';

ngMaterialConfig.$inject = ['$mdThemingProvider'];
export function ngMaterialConfig($mdThemingProvider) {
    $mdThemingProvider.disableTheming();
}



// WEBPACK FOOTER //
// ./resources/assets/js/config/material.config.ts